import { publishIsPublished } from './PublishStore';

export const updatePublishIsPublished = (value) => publishIsPublished.update((oldValue) => value);
